module.exports = __webpack_public_path__ + "static/media/DicomLogo.ee22081f.svg";